module.exports = __webpack_public_path__ + "img/表情包.cd090eb4.png";